import React from 'react';
import SVG from 'react-inlinesvg';
// import { Row, Col } from 'react-bootstrap';
import Layout from '../components/Layout';
import OpenGraphDescription from '../components/OpenGraphDescription';
import OpenGraphTitle from '../components/OpenGraphTitle';
import Section from '../components/Section';
// import PageTitle from '../components/PageTitle';
import SwooptyBg from '../components/SwooptyBg';
// import TextColumns from '../components/TextColumns';
import AboutUsDefaultContent from '../components/AboutUsDefaultContent';
import CtaButtons from '../components/CtaButtons';
import Head from '../components/head';
import { FranchiseeProvider } from '../context/Franchisee';

const iconVenus = '/images/icon-venus.svg';

interface AboutPageProps {
  /* add about page props here */
}

const About: React.FC<AboutPageProps> = () => (
  <FranchiseeProvider>
    <Layout alternateFooter>
      <Head
        slug='about'
        title='Two Maids Professional Cleaning Services'
        description='Our dedication to quality shines in everything we do, from ensuring our services are accessible to all to making every home brighter.'
      />
      <OpenGraphTitle title='Two Maids Professional Cleaning Services' />
      <OpenGraphDescription>Our dedication to quality shines in everything we do, from ensuring our services are accessible to all to making every home brighter.</OpenGraphDescription>
      <div className='top-background-dots mt-0'></div>

      <Section xs={12} md={12} lg={12}>
        <AboutUsDefaultContent />
        {/* <Section padding='bottom'>
          <div className='text-center'>
            <CtaButtons variant='blue' align='center' />
          </div>
        </Section> */}
      </Section>
    </Layout>
  </FranchiseeProvider>
);
export default About;
